import { Component } from '@angular/core';
import { NavigationService } from "@shared/services/navigation-service.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { cloneDeep } from "lodash";
import { EcommerceService } from '../ecommerce.service';
import { ToastService } from '@app/shared/services/toast.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {


  public params: any;
  public totalItems: any;
  public totalPages: any;
  public dataList: any;
  public PAGE_PATH = 'ecommerce/products'
  public productId = '';
  AllList = [
    { value: 'ALL', labelKey: 'store.products.allCategories' }
  ];
  categoriesList: any[] = [];
  selectedItemId: number | null = null;
  selectedItemName: string = '';

  constructor(public service: EcommerceService,
    public navigation: NavigationService,
    public spinner: NgxSpinnerService,
    public router: Router,
    public route: ActivatedRoute,
    public toast: ToastService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.initQueryParamMap();
  }


  public initQueryParamMap() {
    this.route.queryParamMap
      .subscribe((params: any) => {
        this.params = params.params.page ? cloneDeep(params.params) : {
          page: 1,
          srt: 'date',
          srtd: 'desc',
        };
        this.getItems();
      }
      );
  }


  public getItems() {
    this.service.getAllCategories().subscribe((res: any) => {
      var result = res.data;
      if (result != null) {
        var categories = result.map((item: { id: any; name: any; }) => ({
          value: item.id,
          label: item.name,
        }));
        this.categoriesList = [...this.AllList, ...categories];
      } else {
        this.categoriesList = [...this.AllList];
      }
    }, error => {
      console.log(error);
      this.spinner.hide();

    });

    this.service.getProducts(this.params).subscribe((res: any) => {
      this.dataList = res.data;
      this.totalItems = res.total;
      this.totalPages = Math.ceil(parseInt(res.total.toString()) / 5);
      this.totalPages = this.totalPages == 0 ? 1 : this.totalPages;
      this.spinner.hide();

    }, error => {
      console.log(error);
      this.spinner.hide();

    });
  }

  backClick(event: any) {
    this.params.page--;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  nextClick(event: any) {
    this.params.page++;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }


  changeFilter(value: any) {
    if (value !== 'ALL') {
      this.params.categoryId = value;
    } else {
      delete this.params.categoryId;
    }
    this.params.page = 1;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  doSearchByEnter(val: any) {
    this.params.page = 1;
    this.params.search = val?.target?.value;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);

  }

  doSearchByKeyUp(event: any) {
    this.params.search = event.target.value;
    if (this.params.search.length > 3 && event.key !== 'Enter') {
      this.params.page = 1;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
    if (this.params.search.length === 0) {
      delete this.params.search;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
  }

  public goToDetails(product: any) {
    this.router.navigate(['ecommerce/products/' + product.id])
  }

  createNewProduct(id: any) {
    this.router.navigate(['ecommerce/products/' + id])
  }

  openConfirmDialog(item: { id: number; name: string }) {
    this.selectedItemId = item.id;
    this.selectedItemName = item.name;
  }

  deleteItem() {
    if (this.selectedItemId !== null) {
      this.spinner.show();
        this.service.deleteProduct(this.selectedItemId).subscribe((res: any) => {
        this.toast.success("Product Deleted Successfully");
        this.getItems();
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          console.log(error);
        });
      }
  }

}
